import ls from '../../utils/localStorage.js';
import { getShop,getShopDetail } from '../../api/api';

const state = {
  shop_list: '',
  shop_detail: ''
}

const mutations = {
    UPDATE_SHOP_LIST(state,payload) {
        state.shop_list = JSON.parse(payload);
    },
    UPDATE_SHOP_DETAIL(state,payload) {
        state.shop_detail = JSON.parse(payload);
    }
}

const getters = {

}

const actions = {

    // 获取门店列表
    requestShop(store,item) {
        getShop(item.lnglat,item.city).then( data => {
            item.thit.loading = true;
            store.commit('UPDATE_SHOP_LIST',JSON.stringify(data));
        }).catch(error => {
            
        })
    },

    // 获取门店详情
    requestShopDetail(store,item) {
        getShopDetail(item.id,item.lnglat).then( data => {
            store.commit('UPDATE_SHOP_DETAIL',JSON.stringify(data));
        }).catch(error => {
            
        })
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}
